import React, { useMemo } from 'react';
import { useHelmet } from '../../../common';
import { useTranslation } from 'react-i18next';

import './styles.less';

const BackgroundVideo = React.lazy(() => import('../../components/BackgroundVideo'));
const ActionBlock = React.lazy(() => import('../../components/ActionBlock'));

const Home = () => {
  const { t } = useTranslation();
  useHelmet({
    title: t`Home page`,
    description: 'Showroom & Online Store'
  });

  return useMemo(() => (
    <div className="home-wrapper">
      <BackgroundVideo />
      <ActionBlock />
    </div>
  ), []);
};

Home.propTypes = {};

export default Home;